import * as amplitude from '@amplitude/analytics-browser';
import { BaseEvent, EventOptions } from '@amplitude/analytics-types';
import { AppConfig } from 'config';

export const trackAmplitudeEvent = (
  eventInput: string | BaseEvent,
  eventProperties?: Record<string, unknown>,
  eventOptions?: EventOptions,
) => {
  // Only track if Amplitude API key is configured
  if (AppConfig.REACT_APP_AMPLITUDE_KEY) {
    try {
      amplitude.track(eventInput, eventProperties, eventOptions);
    } catch (error) {
      console.warn('Failed to track Amplitude event:', error);
    }
  }
};
